import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,

} from "mdb-react-ui-kit";

import { useState } from "react";
import { Button } from "react-bootstrap";

function WatchVideoBtn(){
    const [openVideoTop, setOpenVideoTop] = useState(false);

    const openClosetoggle = () =>{
        setOpenVideoTop(!openVideoTop)
    }
    return(
        <>
            <div className="d-flex justify-content-center py-1 my-1 py-md-3 my-md-3">
            <Button className="btn watch-now-button btn-primary border-primary-subtle px-2 d-inline-flex" onClick={openClosetoggle} ><FontAwesomeIcon icon={faCirclePlay} size="2xl" style={{color: '#FFF'}} className=" fs-2 px-1 py-1"/><span className=" fs-5 fw-bold px-2">Watch Video ! </span></Button>
            </div>
                <MDBModal staticBackdrop tabIndex='-1' open={openVideoTop} setOpen={setOpenVideoTop}>
                <MDBModalDialog scrollable position='top-right' size="xl">
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>3D Training Website Trailer</MDBModalTitle>
                      <MDBBtn className='btn-close' color='none' onClick={openClosetoggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                    <div className="youtubePlayer-main">
                    <iframe
                        className="youtubePlayer"
                        src={`https://www.youtube.com/embed/95n2uFJWwD8?si=KcokFwR0gIchzEBB&autoplay=${openVideoTop == true?1:0}`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
        
                        </div>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
              </>
    )
}

export default WatchVideoBtn;